import {
  DatabaseUnavailableError,
  PersistenceError,
  PersistenceMigrationError,
  PersistenceReadError,
  PersistenceValidationError,
  PersistenceWriteError,
} from '../../application/errors/PersistenceError';

export type PersistenceOperation = 'open' | 'read' | 'write' | 'migration';

const migrationErrorNames = new Set(['UpgradeError', 'VersionError']);
const unavailableErrorNames = new Set([
  'DatabaseClosedError',
  'InvalidStateError',
  'MissingAPIError',
  'OpenFailedError',
]);
const validationErrorNames = new Set(['BulkError', 'ConstraintError', 'DataError', 'TypeError']);

export function translatePersistenceError(
  operation: PersistenceOperation,
  error: unknown,
): PersistenceError {
  if (error instanceof PersistenceError) {
    return error;
  }

  const name = error instanceof Error ? error.name : '';
  if (migrationErrorNames.has(name) || operation === 'migration') {
    return new PersistenceMigrationError();
  }
  if (unavailableErrorNames.has(name) || operation === 'open') {
    return new DatabaseUnavailableError();
  }
  if (validationErrorNames.has(name)) {
    return new PersistenceValidationError();
  }
  return operation === 'read' ? new PersistenceReadError() : new PersistenceWriteError();
}

export async function executePersistence<Value>(
  operation: PersistenceOperation,
  action: () => Promise<Value>,
): Promise<Value> {
  try {
    return await action();
  } catch (error) {
    throw translatePersistenceError(operation, error);
  }
}
